module.exports = __webpack_public_path__ + "img/defaultAvatar.0feb3c5d.png";